import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withEnabledBlockingInitialNavigation } from "@angular/router";

import { routes } from "./app.routes";
import { provideClientHydration } from "@angular/platform-browser";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { AuthInterceptor } from "./auth.interceptor";
import { initializeAppSession } from "./initializers/session-bootstrap.initializer";
import { AuthService } from "./auth/auth.service";
import { SecureSessionStorageService } from "./services/secure-session-storage.service";
import { LoginDetailsStorageService } from "./services/login-details-storage.service";
import { TempDetailsStorageService } from "./services/temp-details-storage.service";
import { IndicationDetailsStorageService } from "./services/indication-details-storage.service";
import { QuoteDetailsStorageService } from "./services/quote-details-storage.service";
import { PolicyDetailsStorageService } from "./services/policy-details-storage.service";
import { SessionBootstrapService } from "./services/session-bootstrap.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppSession,
      deps: [
        SecureSessionStorageService,
        LoginDetailsStorageService,
        TempDetailsStorageService,
        IndicationDetailsStorageService,
        QuoteDetailsStorageService,
        PolicyDetailsStorageService,
        AuthService,
        SessionBootstrapService,
      ],
      multi: true,
    },
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideClientHydration(),
    provideHttpClient(withInterceptors([AuthInterceptor]),withFetch()),
    provideAnimationsAsync(),
  ],
};
